import { LorenMeteringDataIdsEnum } from "../loren-assets/enums/loren-metering-data-ids.enum";
import { LorenMeteringType } from "../loren-assets/interfaces/loren-metering-type";
import { LorenMetering } from "../loren-assets/interfaces/loren-metering.interface";

export function formatNumericValue(value: string) {
  const number = Number.parseFloat(value);

  // When there is no value or invalid value
  if(Number.isNaN(number)) {
    return '-';
  }

  // Format to 2dp precision
  const formatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

  return formatter.format(number);
}

export function getPrimaryMeteringValue(
  metering: Pick<LorenMetering, 'type' | 'data'>
): string | undefined {
  if (metering.type === LorenMeteringType.NTL_SENSOR) {
    return metering.data.find(
      ({ key }) => key === LorenMeteringDataIdsEnum.NTL_PROBABILITY
    )?.value;
  }

  return metering.data[0]?.value;
}
